// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { Modal, Button, Form, Table, Pagination, Row, Col, Card } from "react-bootstrap";
// import { Tooltip } from 'bootstrap';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { Dropdown } from 'react-bootstrap';
// import { BsThreeDots } from "react-icons/bs";
// import { debounce } from 'lodash';
// import { MdAirplanemodeInactive, MdAirplanemodeActive, MdOutlineUpcoming, MdUpcoming } from "react-icons/md";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";
// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function InactiveProjectList() {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchName, setSearchName] = useState("");
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [selectedimagePath, setSelectedimagePath] = useState(null);
//   const [viewModalImages, setViewModalImages] = useState([]);
//   const searchTimeoutRef = useRef(null);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [amenitiesList, setAmenitiesList] = useState([]);

//   const [editFormData, setEditFormData] = useState({
//     name: "",
//     project_size: "",
//     status: "",
//     project_status: "",
//     project_id: "",
//     newImages: [],
//     images: [],
//     newPDFs: [],
//     pdfs: [],
//     singleImageFile: null,
//     current_single_image_url: null,
//     imageprojectmap: null,
//     imageprojectmap_image_url: null,
//     rera_registration_no: "",
//     location: "",
//     project_type: "",
//     description: "",
//     legality: "",
//     businessVolume: "",
//     city: "",
//     state: "",
//     landmark: "",
//     youtube_links: "",
//     propertyChainPapers: [],
//     availableAmenities: [],
//     keyTransports: [],
//     amenities: [],
//   });

//   const newMultiImageInputRef = useRef(null);
//   const newSingleImageInputRef = useRef(null);
//   const newMapImageInputRef = useRef(null);
//   const newMultiPDFInputRef = useRef(null);

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   useEffect(() => {
//     const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
//     tooltipTriggerList.map((tooltipTriggerEl) => {
//       return new Tooltip(tooltipTriggerEl);
//     });
//   }, [projects]);


//   useEffect(() => {
//     const fetchStates = async () => {
//       try {
//         const token = getAuthToken();
//         if (!token) return;
//         const response = await fetch(`${API_URL}/state-list`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch states.");
//         }
//         const data = await response.json();
//         setStates(data.data || []);
//       } catch (err) {
//         console.error("Fetch states error:", err);
//       }
//     };

//     const fetchAmenities = async () => {
//       try {
//         const token = getAuthToken();
//         if (!token) return;
//         const response = await fetch(`${API_URL}/amenities-list`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch amenities.");
//         }
//         const data = await response.json();
//         setAmenitiesList(data.data || []);
//       } catch (err) {
//         console.error("Fetch amenities error:", err);
//       }
//     };

//     fetchStates();
//     fetchAmenities();
//   }, []);


//   useEffect(() => {
//     const fetchCities = async () => {
//       if (editFormData.state) {
//         try {
//           const token = getAuthToken();
//           if (!token) return;
//           const response = await fetch(`${API_URL}/city-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ state_id: editFormData.state }),
//           });
//           if (!response.ok) {
//             throw new Error("Failed to fetch cities.");
//           }
//           const data = await response.json();
//           setCities(data.data || []);
//         } catch (err) {
//           console.error("Fetch cities error:", err);
//         }
//       } else {
//         setCities([]);
//         setEditFormData((prevData) => ({ ...prevData, city: "" }));
//       }
//     };

//     fetchCities();
//   }, [editFormData.state]);

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({ title: "", text: "", type: "", confirmAction: null });
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const fetchProjects = async (page = 1, name = "") => {
//     // setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         return;
//       }

//       const response = await fetch(
//         `${API_URL}/project-list-inactive?page=${page}&limit=10&name=${name}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal("Authorization Error", "Unauthorized: Please log in again.", "error");
//         }
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch projects.");
//       }

//       const data = await response.json();
//       setProjects(data.data || []);
//       setSelectedimagePath(data.imagePath);
//       setTotalPages(data.totalPages || 1);
//       setCurrentPage(data.currentPage || page);
//     } catch (err) {
//       console.error("Fetch projects error:", err);
//       // if (!showMessageModal) {
//       //   showCustomMessageModal("Error", err.message || "An unexpected error occurred while fetching projects.", "error");
//       // }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProjects(currentPage, searchName);
//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [currentPage]);


//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };


//   const debouncedSearch = debounce((value) => {
//     setCurrentPage(1);
//   }, 500);

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchName(value);
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     searchTimeoutRef.current = setTimeout(() => {
//       setCurrentPage(1);
//       fetchProjects(1, value);
//     }, 500);
//   };

//   const handleViewProject = async (projectId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         return;
//       }

//       const response = await fetch(`${API_URL}/project-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: projectId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch project details.");
//       }

//       const data = await response.json();
//       const projectData = data.data;
//       setSelectedProject(projectData);
//       const imagesArray = projectData.images ? JSON.parse(projectData.images) : [];
//       const parsedPropertyChainPapers = projectData.property_chain_papers ? JSON.parse(projectData.property_chain_papers) : [];
//       setSelectedProject({ ...projectData, property_chain_papers: parsedPropertyChainPapers });
//       setViewModalImages(imagesArray);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("View project error:", err);

//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditProject = async (projectId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/project-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: projectId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch project for editing.");
//       }
//       const data = await response.json();
//       const projectData = data.data;


//       const parsedAmenities = projectData.aminities
//         ? JSON.parse(projectData.aminities).map((a) => String(a.id))
//         : [];
//       const parsedKeyTransports = projectData.key_transport
//         ? JSON.parse(projectData.key_transport)
//         : [];


//       const imagesArrayRaw = projectData.images ? JSON.parse(projectData.images) : [];

//       const imagesArray = imagesArrayRaw.filter(file =>
//         /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.image)
//       );

//       const pdfsArray = imagesArrayRaw.filter(file =>
//         /\.pdf$/i.test(file.image)
//       ).map(file => ({
//         ...file,
//         pdf: file.image,
//         thumbnail: "assets/pdf-thumbnail.png",
//       }));


//       const parsedPropertyChainPapers = projectData.property_chain_papers ? JSON.parse(projectData.property_chain_papers) : [];

//       setEditFormData({
//         name: projectData.name || "",
//         project_size: projectData.total_township_area || "",
//         status: projectData.status || "inactive",
//         project_status: projectData.project_status || "ongoing",
//         project_id: projectData.id || "",
//         newImages: [],
//         images: imagesArray,
//         pdfs: pdfsArray,
//         singleImageFile: null,
//         imageprojectmap: null,
//         current_single_image_url: projectData.thumbnail || null,
//         imageprojectmap_image_url: projectData.map_pdf || null,
//         rera_registration_no: projectData.project_rera_no || "",
//         location: projectData.location || "",
//         project_type: projectData.project_type || "",
//         description: projectData.description || "",
//         legality: projectData.approve_authority || "",
//         businessVolume: projectData.bussiness_volume || "",
//         city: projectData.city || "",
//         state: projectData.state || "",
//         landmark: projectData.land_mark || "",
//         youtube_links: projectData.youtube_links || "",
//         // propertyChainPapers: [],
//         propertyChainPapers: parsedPropertyChainPapers,
//         amenities: parsedAmenities,
//         keyTransports: parsedKeyTransports,
//       });

//       setShowEditModal(true);
//     } catch (err) {
//       console.error("Edit project error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An unexpected error occurred while fetching project for editing.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };


//   const handleNewMultiImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     setEditFormData((prevData) => ({
//       ...prevData,
//       newImages: files,
//     }));
//   };

//   const handleNewMultiPDFChange = (e) => {
//     const files = Array.from(e.target.files);
//     setEditFormData((prevData) => ({
//       ...prevData,
//       newPDFs: [...(prevData.newPDFs || []), ...files],
//     }));
//   };


//   const removeNewMultiPDF = (indexToRemove) => {
//     setEditFormData((prevData) => {
//       const updatedNewPDFs = prevData.newPDFs.filter((_, index) => index !== indexToRemove);
//       if (newMultiPDFInputRef.current && updatedNewPDFs.length === 0) {
//         newMultiPDFInputRef.current.value = "";
//       }
//       return { ...prevData, newPDFs: updatedNewPDFs };
//     });
//   };


//   const handleNewSingleImageChange = (e) => {
//     const file = e.target.files[0];
//     setEditFormData((prevData) => ({
//       ...prevData,
//       singleImageFile: file,
//     }));
//   };

//   const handleNewMapImageChange = (e) => {
//     const file = e.target.files[0];
//     setEditFormData((prevData) => ({
//       ...prevData,
//       imageprojectmap: file,
//     }));
//   };


//   const removeNewMultiImage = (indexToRemove) => {
//     setEditFormData(prevData => {
//       const updatedNewImages = prevData.newImages.filter((_, index) => index !== indexToRemove);
//       if (newMultiImageInputRef.current && updatedNewImages.length === 0) {
//         newMultiImageInputRef.current.value = "";
//       }
//       return { ...prevData, newImages: updatedNewImages };
//     });
//   };


//   const handleDeleteExistingMultiImage = async (imageId) => {
//     showCustomMessageModal(
//       "Confirm Image Deletion",
//       "Are you sure you want to delete this image? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             return;
//           }

//           const response = await fetch(`${API_URL}/project-image-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: imageId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete image.");
//           }
//           showCustomMessageModal("Success", "Project image deleted successfully!", "success");
//           setEditFormData(prevData => ({
//             ...prevData,
//             images: prevData.images.filter(img => img.id !== imageId)
//           }));
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           console.error("Delete image error:", err);
//           // showCustomMessageModal("Error", err.message || "An unexpected error occurred while deleting image.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleDeleteExistingPDF = async (pdfId) => {
//     showCustomMessageModal(
//       "Confirm PDF Deletion",
//       "Are you sure you want to delete this PDF? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Token not found", "error");
//             return;
//           }

//           const response = await fetch(`${API_URL}/project-image-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: pdfId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete PDF.");
//           }

//           showCustomMessageModal("Success", "PDF deleted successfully!", "success");


//           setEditFormData((prevData) => ({
//             ...prevData,
//             pdfs: prevData.pdfs.filter((pdf) => pdf.id !== pdfId),
//           }));

//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           console.error("Delete PDF error:", err);
//           showCustomMessageModal("Error", err.message || "Something went wrong.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleDeleteExistingSingleImage = async (projectId) => {
//     showCustomMessageModal(
//       "Confirm Image Deletion",
//       "Are you sure you want to delete the main project image? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             return;
//           }

//           setEditFormData(prevData => ({ ...prevData, current_single_image_url: null, singleImageFile: null }));
//           if (newSingleImageInputRef.current) {
//             newSingleImageInputRef.current.value = "";
//           }
//           showCustomMessageModal("Success", "Main project image cleared successfully! Save to apply changes.", "success");
//         } catch (err) {
//           console.error("Delete single image error:", err);
//           showCustomMessageModal("Error", err.message || "An unexpected error occurred while deleting the main project image.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleDeleteExistingMapImage = async (projectId) => {
//     showCustomMessageModal(
//       "Confirm Image Deletion",
//       "Are you sure you want to delete the main project image? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             return;
//           }

//           setEditFormData(prevData => ({ ...prevData, imageprojectmap_image_url: null, imageprojectmap: null }));
//           if (newMapImageInputRef.current) {
//             newMapImageInputRef.current.value = "";
//           }
//           showCustomMessageModal("Success", "Main project image cleared successfully! Save to apply changes.", "success");
//         } catch (err) {
//           console.error("Delete single image error:", err);
//           showCustomMessageModal("Error", err.message || "An unexpected error occurred while deleting the main project image.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleDescriptionChange = (event, editor) => {
//     const data = editor.getData();
//     setEditFormData((prevData) => ({
//       ...prevData,
//       description: data,
//     }));
//   };

//   const handleAmenitiesChange = (e) => {
//     const { options } = e.target;
//     const selectedAmenities = [];
//     for (let i = 0; i < options.length; i++) {
//       if (options[i].selected) {
//         selectedAmenities.push(options[i].value);
//       }
//     }
//     setEditFormData((prevData) => ({
//       ...prevData,
//       amenities: selectedAmenities,
//     }));
//   };

//   const handleKeyTransportChange = (index, field, value) => {
//     setEditFormData((prevData) => {
//       const updatedKeyTransports = [...prevData.keyTransports];
//       updatedKeyTransports[index] = {
//         ...updatedKeyTransports[index],
//         [field]: value,
//       };
//       return { ...prevData, keyTransports: updatedKeyTransports };
//     });
//   };

//   const addKeyTransport = () => {
//     setEditFormData((prevData) => ({
//       ...prevData,
//       keyTransports: [...prevData.keyTransports, { name: "", distance: "" }],
//     }));
//   };

//   const removeKeyTransport = (indexToRemove) => {
//     setEditFormData((prevData) => ({
//       ...prevData,
//       keyTransports: prevData.keyTransports.filter(
//         (_, index) => index !== indexToRemove
//       ),
//     }));
//   };

//   // const handleUpdateProject = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);
//   //   setError(null);

//   //   try {
//   //     const token = getAuthToken();
//   //     if (!token) {
//   //       showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//   //       return;
//   //     }
//   //     const formData = new FormData();
//   //     formData.append("project_id", editFormData.project_id);
//   //     formData.append("total_township_area", editFormData.project_size);
//   //     formData.append("project_rera_no", editFormData.rera_registration_no);
//   //     formData.append("location", editFormData.location);
//   //     formData.append("bussiness_volume", editFormData.businessVolume);
//   //     formData.append("description", editFormData.description);
//   //     formData.append("approve_authority", editFormData.legality);
//   //     formData.append("state", editFormData.state);
//   //     formData.append("city", editFormData.city);
//   //     formData.append("land_mark", editFormData.landmark);
//   //     const amenitiesArrayOfObjects = editFormData.amenities.map(id => ({ id: String(id) }));
//   //     formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));
//   //     formData.append("key_transport", JSON.stringify(editFormData.keyTransports));
//   //     formData.append("status", editFormData.status);
//   //     if (editFormData.singleImageFile) {
//   //       formData.append("thumbnail", editFormData.singleImageFile);
//   //     }

//   //     if (editFormData.imageprojectmap) {
//   //       formData.append("map_pdf", editFormData.imageprojectmap);
//   //     }

//   //     formData.append("project_status", editFormData.project_status);

//   //     editFormData.propertyChainPapers.forEach((file) => {
//   //       formData.append("property_chain_papers[]", file);
//   //     });

//   //     editFormData.images.forEach((imageFile) => {
//   //       formData.append("image[]", imageFile);
//   //     });

//   //     const response = await fetch(`${API_URL}/project-update`, {
//   //       method: "POST",
//   //       headers: {
//   //         Authorization: `Bearer ${token}`,
//   //       },
//   //       body: formData,
//   //     });

//   //     if (!response.ok) {
//   //       const errorData = await response.json();
//   //       throw new Error(errorData.message || "Failed to update project.");
//   //     }

//   //     showCustomMessageModal("Success", "Project updated successfully!", "success");
//   //     setShowEditModal(false);
//   //     fetchProjects(currentPage, searchName);
//   //   } catch (err) {
//   //     console.error("Update project error:", err);
//   //     showCustomMessageModal("Error", err.message || "An unexpected error occurred while updating project.", "error");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };



//   const handleUpdateProject = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);

//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         return;
//       }

//       const formData = new FormData();
//       formData.append("project_id", editFormData.project_id);
//       formData.append("total_township_area", editFormData.project_size);
//       formData.append("project_rera_no", editFormData.rera_registration_no);
//       formData.append("location", editFormData.location);
//       formData.append("bussiness_volume", editFormData.businessVolume);
//       formData.append("description", editFormData.description);
//       formData.append("approve_authority", editFormData.legality);
//       formData.append("state", editFormData.state);
//       formData.append("city", editFormData.city);
//       formData.append("land_mark", editFormData.landmark);
//       formData.append("youtube_links", editFormData.youtube_links);
//       formData.append("project_status", editFormData.project_status);
//       formData.append("status", editFormData.status);


//       if (editFormData.singleImageFile) {
//         formData.append("thumbnail", editFormData.singleImageFile);
//       }


//       if (editFormData.imageprojectmap) {
//         formData.append("map_pdf", editFormData.imageprojectmap);
//       }


//       const amenitiesArrayOfObjects = editFormData.amenities.map(id => ({ id: String(id) }));
//       formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));


//       formData.append("key_transport", JSON.stringify(editFormData.keyTransports));


//       if (editFormData.newPDFs && Array.isArray(editFormData.newPDFs)) {
//         editFormData.newPDFs.forEach((file) => {
//           formData.append("property_chain_papers[]", file);
//         });
//       }


//       if (editFormData.newImages && Array.isArray(editFormData.newImages)) {
//         editFormData.newImages.forEach((imageFile) => {
//           formData.append("image[]", imageFile);
//         });
//       }

//       const response = await fetch(`${API_URL}/project-update`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update project.");
//       }

//       const result = await response.json();

//       if (result.success == '1') {
//         showCustomMessageModal("Success", "Project updated successfully!", "success");
//         setShowEditModal(false);
//         fetchProjects(currentPage, searchName);
//       }

//     } catch (err) {
//       console.error("Update project error:", err);
//       showCustomMessageModal("Error", err.message || "An unexpected error occurred while updating project.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };




//   const handleStatusUpdate = async (projectId, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the Project Status to ${newStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             return;
//           }

//           const response = await fetch(`${API_URL}/project-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({
//               status: newStatus,
//               project_id: projectId,
//             }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to update project status.");
//           }

//           showCustomMessageModal("Success", "Project status updated successfully!", "success");
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           console.error("Status update error:", err);
//           showCustomMessageModal("Error", err.message || "An unexpected error occurred while updating project status.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleProjectStatusUpdate = async (projectId, currentProjectStatus) => {
//     const newProjectStatus = currentProjectStatus === "ongoing" ? "complete" : "ongoing";
//     showCustomMessageModal(
//       "Confirm Project Status Change",
//       `Do you want to change the Project Status to ${newProjectStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             return;
//           }

//           const response = await fetch(`${API_URL}/project-project-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({
//               status: newProjectStatus,
//               project_id: projectId,
//             }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to update project status.");
//           }

//           showCustomMessageModal("Success", "Project Status updated successfully!", "success");
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           console.error("Project Status update error:", err);
//           showCustomMessageModal("Error", err.message || "An unexpected error occurred while updating project status.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleDeleteProject = async (projectId) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this project? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             return;
//           }

//           const response = await fetch(`${API_URL}/project-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: projectId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete project.");
//           }

//           showCustomMessageModal("Success", "Project deleted successfully!", "success");
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           console.error("Delete project error:", err);
//           showCustomMessageModal("Error", err.message || "An unexpected error occurred while deleting project.", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setSelectedProject(null);
//     setViewModalImages([]);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedProject(null);
//     setEditFormData({
//       name: "",
//       total_township_area: "",
//       status: "",
//       project_status: "",
//       project_id: "",
//       newImages: [],
//       images: [],
//       singleImageFile: null,
//       current_single_image_url: null,
//       imageprojectmap: null,
//       imageprojectmap_image_url: null,
//       rera_registration_no: "",
//       location: "",
//       project_type: "",
//       description: "",
//       legality: "",
//       businessVolume: "",
//       city: "",
//       state: "",
//       landmark: "",
//       propertyChainPapers: [],
//       availableAmenities: [],
//       keyTransports: [],
//       amenities: [],
//     });
//     if (newMultiImageInputRef.current) {
//       newMultiImageInputRef.current.value = "";
//     }
//     if (newSingleImageInputRef.current) {
//       newSingleImageInputRef.current.value = "";
//     }
//     if (newMapImageInputRef.current) {
//       newMapImageInputRef.current.value = "";
//     }
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="alert alert-danger text-center m-5" role="alert">
//         {error}
//         <button className="btn btn-primary ms-3" onClick={() => fetchProjects()}>
//           Retry
//         </button>
//       </div>
//     );
//   }



//   const parsedImages = typeof viewModalImages === "string"
//     ? JSON.parse(viewModalImages)
//     : viewModalImages || [];

//   const imageFiles = parsedImages.filter((file) =>
//     /\.(jpg|jpeg|png|gif)$/i.test(file)
//   );

//   const pdfFiles = parsedImages.filter((file) =>
//     /\.pdf$/i.test(file)
//   );



//     return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "20px",
//             boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//           }}
//         >
//           {/* Top Gradient Bar */}
//           <div
//             style={{
//               height: "5px",
//               background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//             }}
//           />

//           {/* Header */}
//           <div
//             style={{
//               padding: "24px 30px",
//               background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//               borderBottom: "1.5px solid #e2e8f0",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 🏢
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   Hide Projects
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Manage all hidden real estate projects
//                 </p>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 flexWrap: "wrap",
//               }}
//             >
//               <div className="d-none d-md-block" style={{ position: "relative" }}>
//                 <span
//                   style={{
//                     position: "absolute",
//                     left: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#1e5799",
//                     fontSize: "13px",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   🔍
//                 </span>
//                 <input
//                   type="text"
//                   placeholder="Search by project name..."
//                   value={searchName}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: "240px",
//                     padding: "10px 14px 10px 36px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               </div>

//               <Link
//                 to="/create-project"
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "10px 20px",
//                   borderRadius: "10px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   textDecoration: "none",
//                   boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 <FaPlus />
//                 Project
//               </Link>

//               <div className="d-block d-md-none">
//                 <button
//                   onClick={handleToggle}
//                   style={{
//                     width: "42px",
//                     height: "42px",
//                     borderRadius: "10px",
//                     border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
//                     background: isFilterActive
//                       ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                       : "#ffffff",
//                     color: isFilterActive ? "#ffffff" : "#1e5799",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "18px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Body */}
//           <div style={{ padding: "24px 30px" }}>
//             {isFilterActive && (
//               <div
//                 style={{
//                   background: "#f8fafc",
//                   borderRadius: "14px",
//                   padding: "18px",
//                   marginBottom: "24px",
//                   border: "1.5px solid #e2e8f0",
//                 }}
//               >
//                 <input
//                   type="text"
//                   placeholder="Search by project name"
//                   value={searchName}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               </div>
//             )}

//             {/* Table */}
//             <div
//               style={{
//                 overflowX: "auto",
//                 borderRadius: "14px",
//                 border: "1.5px solid #e2e8f0",
//               }}
//             >
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   fontSize: "13px",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                     }}
//                   >
//                     {[
//                       "S.N",
//                       "Name",
//                       "Total Townships",
//                       "Location",
//                       "Business Vol.",
//                       "Approved Authority",
//                       "Date",
//                       "Status",
//                       "Project Status",
//                       "Actions",
//                     ].map((th, i) => (
//                       <th
//                         key={i}
//                         style={{
//                           padding: "14px 12px",
//                           color: "#ffffff",
//                           fontWeight: "700",
//                           fontSize: "11.5px",
//                           textAlign: "left",
//                           letterSpacing: "0.5px",
//                           textTransform: "uppercase",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {th}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {projects?.length > 0 ? (
//                     [...projects].reverse().map((project, i) => {
//                       return (
//                         <tr
//                           key={project.id}
//                           style={{
//                             borderBottom: "1px solid #f1f5f9",
//                             transition: "background 0.2s ease",
//                           }}
//                           onMouseEnter={(e) =>
//                             (e.currentTarget.style.background = "#f8fafc")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.currentTarget.style.background = "transparent")
//                           }
//                         >
//                           <td
//                             style={{
//                               padding: "12px",
//                               fontWeight: "700",
//                               color: "#1e5799",
//                             }}
//                           >
//                             {i + 1}
//                           </td>
//                           <td
//                             style={{
//                               padding: "12px",
//                               fontWeight: "600",
//                               color: "#1e3a5f",
//                             }}
//                           >
//                             {project.name}
//                           </td>
//                           <td style={{ padding: "12px", color: "#64748b" }}>
//                             {project.total_township_area}
//                           </td>
//                           <td
//                             style={{
//                               padding: "12px",
//                               color: "#334155",
//                               maxWidth: "240px",
//                               fontSize: "12.5px",
//                             }}
//                           >
//                             {project.location}
//                           </td>
//                           <td style={{ padding: "12px", color: "#64748b" }}>
//                             {project.bussiness_volume}
//                           </td>
//                           <td
//                             style={{
//                               padding: "12px",
//                               color: "#334155",
//                               maxWidth: "200px",
//                               fontSize: "12.5px",
//                             }}
//                           >
//                             {project.approve_authority}
//                           </td>
//                           <td
//                             style={{
//                               padding: "12px",
//                               color: "#64748b",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {project.date}
//                           </td>
//                           <td style={{ padding: "12px" }}>
//                             <span
//                               style={{
//                                 display: "inline-block",
//                                 padding: "4px 12px",
//                                 borderRadius: "20px",
//                                 fontSize: "11.5px",
//                                 fontWeight: "700",
//                                 background:
//                                   project.status === "active"
//                                     ? "#e7f9eb"
//                                     : "#feeaeb",
//                                 color:
//                                   project.status === "active"
//                                     ? "#059669"
//                                     : "#dc2626",
//                               }}
//                             >
//                               {project.status === "active" ? "Show" : "Hide"}
//                             </span>
//                           </td>
//                           <td style={{ padding: "12px" }}>
//                             <span
//                               style={{
//                                 display: "inline-block",
//                                 padding: "4px 12px",
//                                 borderRadius: "20px",
//                                 fontSize: "11.5px",
//                                 fontWeight: "700",
//                                 background:
//                                   project.project_status === "ongoing"
//                                     ? "#e8f1fb"
//                                     : "#f3e8ff",
//                                 color:
//                                   project.project_status === "ongoing"
//                                     ? "#1e5799"
//                                     : "#7c3aed",
//                                 textTransform: "capitalize",
//                               }}
//                             >
//                               {project.project_status}
//                             </span>
//                           </td>
//                           <td style={{ padding: "12px" }}>
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 data-bs-toggle="dropdown"
//                                 style={{
//                                   background: "#f8fafc",
//                                   border: "1.5px solid #e2e8f0",
//                                   borderRadius: "8px",
//                                   width: "36px",
//                                   height: "36px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   color: "#1e5799",
//                                 }}
//                               >
//                                 <BsThreeDots size={18} />
//                               </button>
//                               <ul className="dropdown-menu">
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm me-1"
//                                     onClick={() => handleViewProject(project.id)}
//                                   >
//                                     <FaEye /> View
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn edit_btn btn-sm me-1"
//                                     onClick={() => handleEditProject(project.id)}
//                                   >
//                                     <FaEdit /> Edit
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <Button
//                                     variant={
//                                       project.status === "active"
//                                         ? "danger"
//                                         : "success"
//                                     }
//                                     size="sm"
//                                     className="me-1"
//                                     onClick={() =>
//                                       handleStatusUpdate(
//                                         project.id,
//                                         project.status
//                                       )
//                                     }
//                                   >
//                                     {project.status === "active" ? (
//                                       <MdAirplanemodeInactive />
//                                     ) : (
//                                       <MdAirplanemodeActive />
//                                     )}
//                                     {project.status === "active"
//                                       ? "Deactivate"
//                                       : "Activate"}
//                                   </Button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <Button
//                                     variant={
//                                       project.project_status === "ongoing"
//                                         ? "bg-success"
//                                         : "bg-info"
//                                     }
//                                     size="sm"
//                                     className="me-1"
//                                     onClick={() =>
//                                       handleProjectStatusUpdate(
//                                         project.id,
//                                         project.project_status
//                                       )
//                                     }
//                                   >
//                                     {project.project_status === "ongoing" ? (
//                                       <MdUpcoming />
//                                     ) : (
//                                       <MdOutlineUpcoming />
//                                     )}
//                                     {project.project_status === "ongoing"
//                                       ? "Mark Completed"
//                                       : "Mark ongoing"}
//                                   </Button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn delete_btn btn-sm"
//                                     onClick={() =>
//                                       handleDeleteProject(project.id)
//                                     }
//                                   >
//                                     <RiDeleteBin3Fill /> Delete
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="10"
//                         style={{
//                           padding: "50px",
//                           textAlign: "center",
//                           color: "#94a3b8",
//                           fontWeight: "600",
//                         }}
//                       >
//                         📭 No projects found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 marginTop: "20px",
//                 gap: "6px",
//               }}
//             >
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                 }}
//               >
//                 <HiOutlineChevronLeft />
//               </button>

//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handlePageChange(index + 1)}
//                   style={{
//                     width: "38px",
//                     height: "38px",
//                     borderRadius: "10px",
//                     border:
//                       index + 1 === currentPage
//                         ? "none"
//                         : "1.5px solid #e2e8f0",
//                     background:
//                       index + 1 === currentPage
//                         ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                         : "#ffffff",
//                     color: index + 1 === currentPage ? "#ffffff" : "#334155",
//                     fontWeight: "700",
//                     fontSize: "13px",
//                     cursor: "pointer",
//                     boxShadow:
//                       index + 1 === currentPage
//                         ? "0 6px 16px rgba(30, 87, 153, 0.3)"
//                         : "none",
//                   }}
//                 >
//                   {index + 1}
//                 </button>
//               ))}

//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor:
//                     currentPage === totalPages ? "not-allowed" : "pointer",
//                 }}
//               >
//                 <HiChevronRight />
//               </button>
//             </div>

//             {/* ═══════════════════════════════════════════════════════════
//                 YAHAN TERE PURANE MODALS (View, Edit, Message) WAHI PASTE KAR
//                 Unme kuch change nahi karna
//                 ═══════════════════════════════════════════════════════════ */}

//             <Modal show={showViewModal} onHide={handleCloseViewModal} centered size="lg">
//               {/* 👇 Yahan tera purana View Modal ka content paste kar */}
//             </Modal>

//             <Modal show={showEditModal} onHide={handleCloseEditModal} centered size="lg" className="formselectnewdesign">
//               {/* 👇 Yahan tera purana Edit Modal ka content paste kar */}
//             </Modal>

//             {showMessageModal && (
//               <div className="modal d-block" tabIndex="1" style={{
//                 backgroundColor: 'rgba(0,0,0,0.5)',
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 zIndex: 9999,
//               }}>
//                 {/* 👇 Yahan tera purana Message Modal ka content paste kar */}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default InactiveProjectList;

// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { Modal, Button, Form, Row, Col } from "react-bootstrap";
// import { Tooltip } from "bootstrap";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { BsThreeDots } from "react-icons/bs";
// import { debounce } from "lodash";
// import {
//   MdAirplanemodeInactive,
//   MdAirplanemodeActive,
//   MdOutlineUpcoming,
//   MdUpcoming,
// } from "react-icons/md";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function InactiveProjectList() {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchName, setSearchName] = useState("");
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [selectedimagePath, setSelectedimagePath] = useState(null);
//   const [viewModalImages, setViewModalImages] = useState([]);
//   const searchTimeoutRef = useRef(null);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [amenitiesList, setAmenitiesList] = useState([]);

//   const [editFormData, setEditFormData] = useState({
//     name: "",
//     project_size: "",
//     status: "",
//     project_status: "",
//     project_id: "",
//     newImages: [],
//     images: [],
//     newPDFs: [],
//     pdfs: [],
//     singleImageFile: null,
//     current_single_image_url: null,
//     imageprojectmap: null,
//     imageprojectmap_image_url: null,
//     rera_registration_no: "",
//     location: "",
//     project_type: "",
//     description: "",
//     legality: "",
//     businessVolume: "",
//     city: "",
//     state: "",
//     landmark: "",
//     youtube_links: "",
//     propertyChainPapers: [],
//     availableAmenities: [],
//     keyTransports: [],
//     amenities: [],
//   });

//   const newMultiImageInputRef = useRef(null);
//   const newSingleImageInputRef = useRef(null);
//   const newMapImageInputRef = useRef(null);
//   const newMultiPDFInputRef = useRef(null);

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => setIsFilterActive(!isFilterActive);

//   const getAuthToken = () => localStorage.getItem("token");

//   // ═══════════════════════════════════════════
//   // 🔹 TOOLTIP INIT
//   // ═══════════════════════════════════════════
//   useEffect(() => {
//     const tooltipTriggerList = [].slice.call(
//       document.querySelectorAll('[data-bs-toggle="tooltip"]')
//     );
//     tooltipTriggerList.map((el) => new Tooltip(el));
//   }, [projects]);

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH STATES & AMENITIES
//   // ═══════════════════════════════════════════
//   useEffect(() => {
//     const fetchStates = async () => {
//       try {
//         const token = getAuthToken();
//         if (!token) return;
//         const response = await fetch(`${API_URL}/state-list`, {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!response.ok) throw new Error("Failed to fetch states.");
//         const data = await response.json();
//         setStates(data.data || []);
//       } catch (err) {
//         console.error("Fetch states error:", err);
//       }
//     };

//     const fetchAmenities = async () => {
//       try {
//         const token = getAuthToken();
//         if (!token) return;
//         const response = await fetch(`${API_URL}/amenities-list`, {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!response.ok) throw new Error("Failed to fetch amenities.");
//         const data = await response.json();
//         setAmenitiesList(data.data || []);
//       } catch (err) {
//         console.error("Fetch amenities error:", err);
//       }
//     };

//     fetchStates();
//     fetchAmenities();
//   }, []);

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH CITIES
//   // ═══════════════════════════════════════════
//   useEffect(() => {
//     const fetchCities = async () => {
//       if (editFormData.state) {
//         try {
//           const token = getAuthToken();
//           if (!token) return;
//           const response = await fetch(`${API_URL}/city-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ state_id: editFormData.state }),
//           });
//           if (!response.ok) throw new Error("Failed to fetch cities.");
//           const data = await response.json();
//           setCities(data.data || []);
//         } catch (err) {
//           console.error("Fetch cities error:", err);
//         }
//       } else {
//         setCities([]);
//         setEditFormData((prev) => ({ ...prev, city: "" }));
//       }
//     };
//     fetchCities();
//   }, [editFormData.state]);

//   // ═══════════════════════════════════════════
//   // 🔹 MESSAGE MODAL
//   // ═══════════════════════════════════════════
//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH PROJECTS (INACTIVE)
//   // ═══════════════════════════════════════════
//   const fetchProjects = async (page = 1, name = "") => {
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(
//         `${API_URL}/project-list-inactive?page=${page}&limit=10&name=${name}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error"
//           );
//         }
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch projects.");
//       }

//       const data = await response.json();
//       setProjects(data.data || []);
//       setSelectedimagePath(data.imagePath);
//       setTotalPages(data.totalPages || 1);
//       setCurrentPage(data.currentPage || page);
//     } catch (err) {
//       console.error("Fetch projects error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProjects(currentPage, searchName);
//     return () => {
//       if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchName(value);
//     if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//     searchTimeoutRef.current = setTimeout(() => {
//       setCurrentPage(1);
//       fetchProjects(1, value);
//     }, 500);
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 VIEW PROJECT
//   // ═══════════════════════════════════════════
//   const handleViewProject = async (projectId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/project-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: projectId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch project details.");
//       }

//       const data = await response.json();
//       const projectData = data.data;

//       const safeParse = (val) => {
//         if (!val) return [];
//         if (Array.isArray(val)) return val;
//         try {
//           const parsed = JSON.parse(val);
//           return Array.isArray(parsed) ? parsed : [];
//         } catch {
//           return [];
//         }
//       };

//       const imagesArray = safeParse(projectData.images);
//       const amenitiesArray = safeParse(projectData.aminities);
//       const parsedPropertyChainPapers = safeParse(
//         projectData.property_chain_papers
//       );

//       setSelectedProject({
//         ...projectData,
//         images: imagesArray,
//         aminities: amenitiesArray,
//         property_chain_papers: parsedPropertyChainPapers,
//       });

//       setViewModalImages(imagesArray);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("View project error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "Failed to load project details.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 EDIT PROJECT
//   // ═══════════════════════════════════════════
//   const handleEditProject = async (projectId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/project-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: projectId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           errorData.message || "Failed to fetch project for editing."
//         );
//       }
//       const data = await response.json();
//       const projectData = data.data;

//       const safeParse = (val) => {
//         if (!val) return [];
//         if (Array.isArray(val)) return val;
//         try {
//           const parsed = JSON.parse(val);
//           return Array.isArray(parsed) ? parsed : [];
//         } catch {
//           return [];
//         }
//       };

//       let parsedAmenities = [];
//       if (projectData.aminities) {
//         const amenitiesData = safeParse(projectData.aminities);
//         parsedAmenities = amenitiesData.map((a) => String(a.id || a));
//       }

//       const parsedKeyTransports = safeParse(projectData.key_transport);
//       const imagesArrayRaw = safeParse(projectData.images);

//       const imagesArray = imagesArrayRaw.filter((file) =>
//         /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.image || file)
//       );

//       const pdfsArray = imagesArrayRaw
//         .filter((file) => /\.pdf$/i.test(file.image || file))
//         .map((file) => ({
//           ...file,
//           pdf: file.image || file,
//           thumbnail: "assets/pdf-thumbnail.png",
//         }));

//       const parsedPropertyChainPapers = safeParse(
//         projectData.property_chain_papers
//       );

//       setEditFormData({
//         name: projectData.name || "",
//         project_size: projectData.total_township_area || "",
//         status: projectData.status || "inactive",
//         project_status: projectData.project_status || "ongoing",
//         project_id: projectData.id || "",
//         newImages: [],
//         images: imagesArray,
//         pdfs: pdfsArray,
//         newPDFs: [],
//         singleImageFile: null,
//         imageprojectmap: null,
//         current_single_image_url: projectData.thumbnail || null,
//         imageprojectmap_image_url: projectData.map_pdf || null,
//         rera_registration_no: projectData.project_rera_no || "",
//         location: projectData.location || "",
//         project_type: projectData.project_type || "",
//         description: projectData.description || "",
//         legality: projectData.approve_authority || "",
//         businessVolume: projectData.bussiness_volume || "",
//         city: projectData.city || "",
//         state: projectData.state || "",
//         landmark: projectData.land_mark || "",
//         youtube_links: projectData.youtube_links || "",
//         propertyChainPapers: parsedPropertyChainPapers,
//         amenities: parsedAmenities,
//         keyTransports: parsedKeyTransports,
//       });

//       setShowEditModal(true);
//     } catch (err) {
//       console.error("Edit project error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An unexpected error occurred.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 FORM HANDLERS
//   // ═══════════════════════════════════════════
//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleNewMultiImageChange = (e) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       newImages: Array.from(e.target.files),
//     }));

//   const handleNewMultiPDFChange = (e) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       newPDFs: [...(prev.newPDFs || []), ...Array.from(e.target.files)],
//     }));

//   const handleNewSingleImageChange = (e) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       singleImageFile: e.target.files[0],
//     }));

//   const handleNewMapImageChange = (e) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       imageprojectmap: e.target.files[0],
//     }));

//   const removeNewMultiImage = (i) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       newImages: prev.newImages.filter((_, idx) => idx !== i),
//     }));

//   const removeNewMultiPDF = (i) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       newPDFs: prev.newPDFs.filter((_, idx) => idx !== i),
//     }));

//   const handleDescriptionChange = (event, editor) =>
//     setEditFormData((prev) => ({ ...prev, description: editor.getData() }));

//   const handleAmenitiesChange = (e) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       amenities: Array.from(e.target.selectedOptions).map((o) => o.value),
//     }));

//   const handleKeyTransportChange = (index, field, value) =>
//     setEditFormData((prev) => {
//       const updated = [...prev.keyTransports];
//       updated[index] = { ...updated[index], [field]: value };
//       return { ...prev, keyTransports: updated };
//     });

//   const addKeyTransport = () =>
//     setEditFormData((prev) => ({
//       ...prev,
//       keyTransports: [...prev.keyTransports, { name: "", distance: "" }],
//     }));

//   const removeKeyTransport = (i) =>
//     setEditFormData((prev) => ({
//       ...prev,
//       keyTransports: prev.keyTransports.filter((_, idx) => idx !== i),
//     }));

//   // ═══════════════════════════════════════════
//   // 🔹 UPDATE PROJECT
//   // ═══════════════════════════════════════════
//   const handleUpdateProject = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }

//       const formData = new FormData();
//       formData.append("project_id", editFormData.project_id);
//       formData.append("total_township_area", editFormData.project_size);
//       formData.append("project_rera_no", editFormData.rera_registration_no);
//       formData.append("location", editFormData.location);
//       formData.append("bussiness_volume", editFormData.businessVolume);
//       formData.append("description", editFormData.description);
//       formData.append("approve_authority", editFormData.legality);
//       formData.append("state", editFormData.state);
//       formData.append("city", editFormData.city);
//       formData.append("land_mark", editFormData.landmark);
//       formData.append("youtube_links", editFormData.youtube_links);
//       formData.append("project_status", editFormData.project_status);
//       formData.append("status", editFormData.status);

//       if (editFormData.singleImageFile) {
//         formData.append("thumbnail", editFormData.singleImageFile);
//       }
//       if (editFormData.imageprojectmap) {
//         formData.append("map_pdf", editFormData.imageprojectmap);
//       }

//       const amenitiesArrayOfObjects = editFormData.amenities.map((id) => ({
//         id: String(id),
//       }));
//       formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));
//       formData.append("key_transport", JSON.stringify(editFormData.keyTransports));

//       if (editFormData.newPDFs?.length) {
//         editFormData.newPDFs.forEach((f) =>
//           formData.append("property_chain_papers[]", f)
//         );
//       }
//       if (editFormData.newImages?.length) {
//         editFormData.newImages.forEach((f) => formData.append("image[]", f));
//       }

//       const response = await fetch(`${API_URL}/project-update`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update project.");
//       }

//       const result = await response.json();
//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           "Project updated successfully!",
//           "success"
//         );
//         setShowEditModal(false);
//         fetchProjects(currentPage, searchName);
//       }
//     } catch (err) {
//       console.error("Update project error:", err);
//       showCustomMessageModal("Error", err.message || "Error occurred.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 STATUS UPDATES
//   // ═══════════════════════════════════════════
//   const handleStatusUpdate = (projectId, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the Project Status to ${newStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(`${API_URL}/project-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ status: newStatus, project_id: projectId }),
//           });
//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to update status.");
//           }
//           showCustomMessageModal("Success", "Project status updated!", "success");
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           showCustomMessageModal("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleProjectStatusUpdate = (projectId, currentProjectStatus) => {
//     const newProjectStatus =
//       currentProjectStatus === "ongoing" ? "complete" : "ongoing";
//     showCustomMessageModal(
//       "Confirm Project Status Change",
//       `Do you want to change to ${newProjectStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(
//             `${API_URL}/project-project-status-update`,
//             {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//               body: JSON.stringify({
//                 status: newProjectStatus,
//                 project_id: projectId,
//               }),
//             }
//           );
//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to update.");
//           }
//           showCustomMessageModal("Success", "Project Status updated!", "success");
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           showCustomMessageModal("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleDeleteProject = (projectId) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this project? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(`${API_URL}/project-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: projectId }),
//           });
//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete project.");
//           }
//           showCustomMessageModal(
//             "Success",
//             "Project deleted successfully!",
//             "success"
//           );
//           fetchProjects(currentPage, searchName);
//         } catch (err) {
//           showCustomMessageModal("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setSelectedProject(null);
//     setViewModalImages([]);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedProject(null);
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 LOADING / ERROR
//   // ═══════════════════════════════════════════
//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "80vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         }}
//       >
//         <div
//           style={{
//             width: "50px",
//             height: "50px",
//             border: "4px solid #e2e8f0",
//             borderTop: "4px solid #1e5799",
//             borderRadius: "50%",
//             animation: "spin 0.8s linear infinite",
//           }}
//         />
//         <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="alert alert-danger text-center m-5" role="alert">
//         {error}
//         <button className="btn btn-primary ms-3" onClick={() => fetchProjects()}>
//           Retry
//         </button>
//       </div>
//     );
//   }

//   const parsedImages =
//     typeof viewModalImages === "string"
//       ? JSON.parse(viewModalImages)
//       : viewModalImages || [];

//   const imageFiles = parsedImages.filter((file) =>
//     /\.(jpg|jpeg|png|gif|webp)$/i.test(
//       typeof file === "string" ? file : file.image
//     )
//   );

//   const pdfFiles = parsedImages.filter((file) =>
//     /\.pdf$/i.test(typeof file === "string" ? file : file.image)
//   );

//   // ═══════════════════════════════════════════
//   // 🎨 UI RENDER
//   // ═══════════════════════════════════════════
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "20px",
//             boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//           }}
//         >
//           {/* Top Gradient */}
//           <div
//             style={{
//               height: "5px",
//               background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//             }}
//           />

//           {/* Header */}
//           <div
//             style={{
//               padding: "24px 30px",
//               background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//               borderBottom: "1.5px solid #e2e8f0",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 🏢
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   Hide Projects
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Manage all hidden real estate projects
//                 </p>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 flexWrap: "wrap",
//               }}
//             >
//               <div className="d-none d-md-block" style={{ position: "relative" }}>
//                 <span
//                   style={{
//                     position: "absolute",
//                     left: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#1e5799",
//                     fontSize: "13px",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   🔍
//                 </span>
//                 <input
//                   type="text"
//                   placeholder="Search by project name..."
//                   value={searchName}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: "240px",
//                     padding: "10px 14px 10px 36px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               </div>

//               <Link
//                 to="/create-project"
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "10px 20px",
//                   borderRadius: "10px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   textDecoration: "none",
//                   boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 <FaPlus /> Project
//               </Link>
//             </div>
//           </div>

//           {/* Body */}
//           <div style={{ padding: "24px 30px" }}>
//             {isFilterActive && (
//               <div
//                 style={{
//                   background: "#f8fafc",
//                   borderRadius: "14px",
//                   padding: "18px",
//                   marginBottom: "24px",
//                   border: "1.5px solid #e2e8f0",
//                 }}
//               >
//                 <input
//                   type="text"
//                   placeholder="Search by project name"
//                   value={searchName}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "500",
//                     color: "#1e3a5f",
//                     outline: "none",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               </div>
//             )}

//             {/* Table */}
//             <div
//               style={{
//                 overflowX: "auto",
//                 overflowY: "visible",
//                 borderRadius: "14px",
//                 border: "1.5px solid #e2e8f0",
//               }}
//             >
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   fontSize: "13px",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                     }}
//                   >
//                     {[
//                       "S.N",
//                       "Name",
//                       "Total Townships",
//                       "Location",
//                       "Business Vol.",
//                       "Approved Authority",
//                       "Date",
//                       "Status",
//                       "Project Status",
//                       "Actions",
//                     ].map((th, i) => (
//                       <th
//                         key={i}
//                         style={{
//                           padding: "14px 12px",
//                           color: "#ffffff",
//                           fontWeight: "700",
//                           fontSize: "11.5px",
//                           textAlign: "left",
//                           letterSpacing: "0.5px",
//                           textTransform: "uppercase",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {th}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {projects?.length > 0 ? (
//                     [...projects].reverse().map((project, i) => (
//                       <tr
//                         key={project.id}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.background = "#f8fafc")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.background = "transparent")
//                         }
//                       >
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontWeight: "700",
//                             color: "#1e5799",
//                           }}
//                         >
//                           {i + 1}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontWeight: "600",
//                             color: "#1e3a5f",
//                           }}
//                         >
//                           {project.name}
//                         </td>
//                         <td style={{ padding: "12px", color: "#64748b" }}>
//                           {project.total_township_area}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             color: "#334155",
//                             maxWidth: "240px",
//                             fontSize: "12.5px",
//                           }}
//                         >
//                           {project.location}
//                         </td>
//                         <td style={{ padding: "12px", color: "#64748b" }}>
//                           {project.bussiness_volume}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             color: "#334155",
//                             maxWidth: "200px",
//                             fontSize: "12.5px",
//                           }}
//                         >
//                           {project.approve_authority}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             color: "#64748b",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {project.date}
//                         </td>
//                         <td style={{ padding: "12px" }}>
//                           <span
//                             style={{
//                               display: "inline-block",
//                               padding: "4px 12px",
//                               borderRadius: "20px",
//                               fontSize: "11.5px",
//                               fontWeight: "700",
//                               background:
//                                 project.status === "active"
//                                   ? "#e7f9eb"
//                                   : "#feeaeb",
//                               color:
//                                 project.status === "active"
//                                   ? "#059669"
//                                   : "#dc2626",
//                             }}
//                           >
//                             {project.status === "active" ? "Show" : "Hide"}
//                           </span>
//                         </td>
//                         <td style={{ padding: "12px" }}>
//                           <span
//                             style={{
//                               display: "inline-block",
//                               padding: "4px 12px",
//                               borderRadius: "20px",
//                               fontSize: "11.5px",
//                               fontWeight: "700",
//                               background:
//                                 project.project_status === "ongoing"
//                                   ? "#e8f1fb"
//                                   : "#f3e8ff",
//                               color:
//                                 project.project_status === "ongoing"
//                                   ? "#1e5799"
//                                   : "#7c3aed",
//                               textTransform: "capitalize",
//                             }}
//                           >
//                             {project.project_status}
//                           </span>
//                         </td>
//                         <td style={{ padding: "12px" }}>
//                           <div className="dropdown">
//                             <button
//                               className="btn dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                               data-bs-boundary="viewport"
//                               data-bs-popper-config='{"strategy":"fixed"}'
//                               aria-expanded="false"
//                               style={{
//                                 background: "#f8fafc",
//                                 border: "1.5px solid #e2e8f0",
//                                 borderRadius: "8px",
//                                 width: "36px",
//                                 height: "36px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 color: "#1e5799",
//                                 padding: 0,
//                               }}
//                             >
//                               <BsThreeDots size={18} />
//                             </button>
//                             <ul
//                               className="dropdown-menu"
//                               style={{
//                                 zIndex: 9999,
//                                 borderRadius: "14px",
//                                 border: "none",
//                                 padding: "8px",
//                                 boxShadow:
//                                   "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
//                                 minWidth: "230px",
//                                 marginTop: "8px",
//                                 background: "#ffffff",
//                               }}
//                             >
//                               {/* View */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() => handleViewProject(project.id)}
//                                   style={dropdownItem}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#e8f1fb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span
//                                     style={iconBadge("#e8f1fb", "#1e5799")}
//                                   >
//                                     <FaEye size={13} />
//                                   </span>
//                                   View Details
//                                 </button>
//                               </li>

//                               {/* Edit */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() => handleEditProject(project.id)}
//                                   style={dropdownItem}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#e7f9eb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span
//                                     style={iconBadge("#e7f9eb", "#059669")}
//                                   >
//                                     <FaEdit size={13} />
//                                   </span>
//                                   Edit Project
//                                 </button>
//                               </li>

//                               <li>
//                                 <hr
//                                   style={{
//                                     margin: "6px 8px",
//                                     border: "none",
//                                     borderTop: "1.5px dashed #e2e8f0",
//                                   }}
//                                 />
//                               </li>

//                               {/* Activate / Deactivate */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() =>
//                                     handleStatusUpdate(project.id, project.status)
//                                   }
//                                   style={{
//                                     ...dropdownItem,
//                                     color:
//                                       project.status === "active"
//                                         ? "#dc2626"
//                                         : "#059669",
//                                   }}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background =
//                                       project.status === "active"
//                                         ? "#feeaeb"
//                                         : "#e7f9eb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span
//                                     style={iconBadge(
//                                       project.status === "active"
//                                         ? "#feeaeb"
//                                         : "#e7f9eb",
//                                       project.status === "active"
//                                         ? "#dc2626"
//                                         : "#059669"
//                                     )}
//                                   >
//                                     {project.status === "active" ? (
//                                       <MdAirplanemodeInactive size={13} />
//                                     ) : (
//                                       <MdAirplanemodeActive size={13} />
//                                     )}
//                                   </span>
//                                   {project.status === "active"
//                                     ? "Deactivate"
//                                     : "Activate"}
//                                 </button>
//                               </li>

//                               {/* Mark Completed */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() =>
//                                     handleProjectStatusUpdate(
//                                       project.id,
//                                       project.project_status
//                                     )
//                                   }
//                                   style={{
//                                     ...dropdownItem,
//                                     color: "#7c3aed",
//                                   }}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#f3e8ff";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span
//                                     style={iconBadge("#f3e8ff", "#7c3aed")}
//                                   >
//                                     {project.project_status === "ongoing" ? (
//                                       <MdUpcoming size={13} />
//                                     ) : (
//                                       <MdOutlineUpcoming size={13} />
//                                     )}
//                                   </span>
//                                   {project.project_status === "ongoing"
//                                     ? "Mark Completed"
//                                     : "Mark Ongoing"}
//                                 </button>
//                               </li>

//                               <li>
//                                 <hr
//                                   style={{
//                                     margin: "6px 8px",
//                                     border: "none",
//                                     borderTop: "1.5px dashed #e2e8f0",
//                                   }}
//                                 />
//                               </li>

//                               {/* Delete */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() => handleDeleteProject(project.id)}
//                                   style={{
//                                     ...dropdownItem,
//                                     color: "#dc2626",
//                                   }}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#feeaeb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span
//                                     style={iconBadge("#feeaeb", "#dc2626")}
//                                   >
//                                     <RiDeleteBin3Fill size={13} />
//                                   </span>
//                                   Delete Project
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="10"
//                         style={{
//                           padding: "50px",
//                           textAlign: "center",
//                           color: "#94a3b8",
//                           fontWeight: "600",
//                         }}
//                       >
//                         📭 No projects found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 marginTop: "20px",
//                 gap: "6px",
//               }}
//             >
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={paginationBtn(currentPage === 1)}
//               >
//                 <HiOutlineChevronLeft />
//               </button>
//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handlePageChange(index + 1)}
//                   style={{
//                     width: "38px",
//                     height: "38px",
//                     borderRadius: "10px",
//                     border:
//                       index + 1 === currentPage
//                         ? "none"
//                         : "1.5px solid #e2e8f0",
//                     background:
//                       index + 1 === currentPage
//                         ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                         : "#ffffff",
//                     color: index + 1 === currentPage ? "#ffffff" : "#334155",
//                     fontWeight: "700",
//                     fontSize: "13px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {index + 1}
//                 </button>
//               ))}
//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={paginationBtn(currentPage === totalPages)}
//               >
//                 <HiChevronRight />
//               </button>
//             </div>

//             {/* ═══════════════════════════════════════════ */}
//             {/* 🎯 VIEW MODAL */}
//             {/* ═══════════════════════════════════════════ */}
//             <Modal
//               show={showViewModal}
//               onHide={handleCloseViewModal}
//               size="xl"
//               centered
//               backdrop="static"
//               style={{ zIndex: 99999 }}
//             >
//               <Modal.Header
//                 closeButton
//                 style={{
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   border: "none",
//                 }}
//               >
//                 <Modal.Title style={{ fontWeight: "800" }}>
//                   📋 Project Details
//                 </Modal.Title>
//               </Modal.Header>
//               <Modal.Body
//                 style={{ padding: "24px", maxHeight: "75vh", overflowY: "auto" }}
//               >
//                 {selectedProject && (
//                   <>
//                     {selectedProject.thumbnail && (
//                       <div style={{ marginBottom: "20px" }}>
//                         <strong style={{ color: "#1e5799" }}>Main Image:</strong>
//                         <div style={{ marginTop: "8px" }}>
//                           <img
//                             src={`${imageAPIURL}/project/${selectedProject.thumbnail}`}
//                             alt="thumbnail"
//                             style={{
//                               width: "100%",
//                               maxHeight: "340px",
//                               objectFit: "cover",
//                               borderRadius: "12px",
//                               border: "1.5px solid #e2e8f0",
//                               boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                             }}
//                             onError={(e) => (e.target.style.display = "none")}
//                           />
//                         </div>
//                       </div>
//                     )}

//                     <Row className="mb-3">
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>Project Name:</strong>
//                         <p style={textDark}>{selectedProject.name || "N/A"}</p>
//                       </Col>
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>
//                           Total Township Area:
//                         </strong>
//                         <p style={textDark}>
//                           {selectedProject.total_township_area || "N/A"}
//                         </p>
//                       </Col>
//                     </Row>

//                     <Row className="mb-3">
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>Location:</strong>
//                         <p style={textDark}>{selectedProject.location || "N/A"}</p>
//                       </Col>
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>
//                           State / City:
//                         </strong>
//                         <p style={textDark}>
//                           {selectedProject.state || "N/A"} /{" "}
//                           {selectedProject.city || "N/A"}
//                         </p>
//                       </Col>
//                     </Row>

//                     <Row className="mb-3">
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>RERA No:</strong>
//                         <p style={textDark}>
//                           {selectedProject.project_rera_no || "N/A"}
//                         </p>
//                       </Col>
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>
//                           Approved Authority:
//                         </strong>
//                         <p style={textDark}>
//                           {selectedProject.approve_authority || "N/A"}
//                         </p>
//                       </Col>
//                     </Row>

//                     <Row className="mb-3">
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>
//                           Business Volume:
//                         </strong>
//                         <p style={textDark}>
//                           {selectedProject.bussiness_volume || "N/A"}
//                         </p>
//                       </Col>
//                       <Col md={6}>
//                         <strong style={{ color: "#1e5799" }}>Landmark:</strong>
//                         <p style={textDark}>
//                           {selectedProject.land_mark || "N/A"}
//                         </p>
//                       </Col>
//                     </Row>

//                     {selectedProject.location_map && (
//                       <Row className="mb-3">
//                         <Col md={12}>
//                           <strong style={{ color: "#1e5799" }}>
//                             Location Map:
//                           </strong>
//                           <p style={{ margin: "4px 0" }}>
//                             <a
//                               href={selectedProject.location_map}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               style={{ color: "#1e5799", fontWeight: "600" }}
//                             >
//                               🗺️ Open in Google Maps
//                             </a>
//                           </p>
//                         </Col>
//                       </Row>
//                     )}

//                     <Row className="mb-3">
//                       <Col md={12}>
//                         <strong style={{ color: "#1e5799" }}>Description:</strong>
//                         <div
//                           style={{ margin: "4px 0", color: "#334155" }}
//                           dangerouslySetInnerHTML={{
//                             __html: selectedProject.description || "N/A",
//                           }}
//                         />
//                       </Col>
//                     </Row>

//                     {selectedProject.images &&
//                       selectedProject.images.length > 0 && (
//                         <div className="mb-3">
//                           <strong style={{ color: "#1e5799" }}>
//                             Project Gallery:
//                           </strong>
//                           <div
//                             style={{
//                               display: "grid",
//                               gridTemplateColumns:
//                                 "repeat(auto-fill, minmax(140px, 1fr))",
//                               gap: "10px",
//                               marginTop: "10px",
//                             }}
//                           >
//                             {selectedProject.images.map((img, idx) => {
//                               const imgName =
//                                 typeof img === "string" ? img : img.image;
//                               return (
//                                 <div
//                                   key={idx}
//                                   style={{
//                                     borderRadius: "10px",
//                                     overflow: "hidden",
//                                     border: "1.5px solid #e2e8f0",
//                                     boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//                                   }}
//                                 >
//                                   <img
//                                     src={`${imageAPIURL}/project/${imgName}`}
//                                     alt={`project-${idx}`}
//                                     style={{
//                                       width: "100%",
//                                       height: "120px",
//                                       objectFit: "cover",
//                                       display: "block",
//                                       cursor: "pointer",
//                                       transition: "transform 0.3s ease",
//                                     }}
//                                     onMouseEnter={(e) =>
//                                       (e.target.style.transform = "scale(1.08)")
//                                     }
//                                     onMouseLeave={(e) =>
//                                       (e.target.style.transform = "scale(1)")
//                                     }
//                                     onClick={() =>
//                                       window.open(
//                                         `${imageAPIURL}/project/${imgName}`,
//                                         "_blank"
//                                       )
//                                     }
//                                     onError={(e) =>
//                                       (e.target.style.display = "none")
//                                     }
//                                   />
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       )}

//                     {selectedProject.aminities &&
//                       selectedProject.aminities.length > 0 && (
//                         <div className="mb-3">
//                           <strong style={{ color: "#1e5799" }}>Amenities:</strong>
//                           <div
//                             style={{
//                               display: "flex",
//                               flexWrap: "wrap",
//                               gap: "8px",
//                               marginTop: "10px",
//                             }}
//                           >
//                             {selectedProject.aminities.map((am, idx) => (
//                               <span
//                                 key={idx}
//                                 style={{
//                                   padding: "6px 12px",
//                                   borderRadius: "20px",
//                                   background: "#e8f1fb",
//                                   color: "#1e5799",
//                                   fontSize: "12px",
//                                   fontWeight: "600",
//                                 }}
//                               >
//                                 ✨ {typeof am === "object" ? am.name : am}
//                               </span>
//                             ))}
//                           </div>
//                         </div>
//                       )}

//                     {pdfFiles.length > 0 && (
//                       <div className="mb-3">
//                         <strong style={{ color: "#1e5799" }}>
//                           Project PDFs:
//                         </strong>
//                         <ul style={{ marginTop: "8px" }}>
//                           {pdfFiles.map((pdf, idx) => {
//                             const pName =
//                               typeof pdf === "string" ? pdf : pdf.image;
//                             return (
//                               <li key={idx}>
//                                 <a
//                                   href={`${imageAPIURL}/project/${pName}`}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   style={{ color: "#1e5799", fontWeight: "600" }}
//                                 >
//                                   📄 {pName}
//                                 </a>
//                               </li>
//                             );
//                           })}
//                         </ul>
//                       </div>
//                     )}
//                   </>
//                 )}
//               </Modal.Body>
//               <Modal.Footer>
//                 <Button variant="secondary" onClick={handleCloseViewModal}>
//                   Close
//                 </Button>
//               </Modal.Footer>
//             </Modal>

//             {/* ═══════════════════════════════════════════ */}
//             {/* 🎯 EDIT MODAL */}
//             {/* ═══════════════════════════════════════════ */}
//             <Modal
//               show={showEditModal}
//               onHide={handleCloseEditModal}
//               size="lg"
//               centered
//               backdrop="static"
//               style={{ zIndex: 99999 }}
//             >
//               <Modal.Header
//                 closeButton
//                 style={{
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   border: "none",
//                 }}
//               >
//                 <Modal.Title style={{ fontWeight: "800" }}>
//                   ✏️ Edit Project
//                 </Modal.Title>
//               </Modal.Header>
//               <Modal.Body
//                 style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
//               >
//                 <Form onSubmit={handleUpdateProject}>
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>Project Name</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="name"
//                           value={editFormData.name}
//                           onChange={handleEditFormChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>
//                           Total Township Area
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="project_size"
//                           value={editFormData.project_size}
//                           onChange={handleEditFormChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>RERA No</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="rera_registration_no"
//                           value={editFormData.rera_registration_no}
//                           onChange={handleEditFormChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>Location</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="location"
//                           value={editFormData.location}
//                           onChange={handleEditFormChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>
//                           Business Volume
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="businessVolume"
//                           value={editFormData.businessVolume}
//                           onChange={handleEditFormChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>
//                           Approved Authority
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="legality"
//                           value={editFormData.legality}
//                           onChange={handleEditFormChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>State</Form.Label>
//                         <Form.Select
//                           name="state"
//                           value={editFormData.state}
//                           onChange={handleEditFormChange}
//                         >
//                           <option value="">Select State</option>
//                           {states.map((s) => (
//                             <option key={s.id} value={s.id}>
//                               {s.name}
//                             </option>
//                           ))}
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>City</Form.Label>
//                         <Form.Select
//                           name="city"
//                           value={editFormData.city}
//                           onChange={handleEditFormChange}
//                         >
//                           <option value="">Select City</option>
//                           {cities.map((c) => (
//                             <option key={c.id} value={c.id}>
//                               {c.name}
//                             </option>
//                           ))}
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Form.Group className="mb-3">
//                     <Form.Label style={labelStyle}>Landmark</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="landmark"
//                       value={editFormData.landmark}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label style={labelStyle}>YouTube Link</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="youtube_links"
//                       value={editFormData.youtube_links}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label style={labelStyle}>Description</Form.Label>
//                     <CKEditor
//                       editor={ClassicEditor}
//                       data={editFormData.description}
//                       onChange={handleDescriptionChange}
//                     />
//                   </Form.Group>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>Status</Form.Label>
//                         <Form.Select
//                           name="status"
//                           value={editFormData.status}
//                           onChange={handleEditFormChange}
//                         >
//                           <option value="active">Active</option>
//                           <option value="inactive">Inactive</option>
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label style={labelStyle}>
//                           Project Status
//                         </Form.Label>
//                         <Form.Select
//                           name="project_status"
//                           value={editFormData.project_status}
//                           onChange={handleEditFormChange}
//                         >
//                           <option value="ongoing">Ongoing</option>
//                           <option value="complete">Complete</option>
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Button
//                     variant="primary"
//                     type="submit"
//                     disabled={loading}
//                     style={{
//                       width: "100%",
//                       padding: "12px",
//                       borderRadius: "10px",
//                       fontWeight: "700",
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       border: "none",
//                     }}
//                   >
//                     {loading ? "Updating..." : "Update Project"}
//                   </Button>
//                 </Form>
//               </Modal.Body>
//             </Modal>

//             {/* ═══════════════════════════════════════════ */}
//             {/* 🎯 MESSAGE MODAL */}
//             {/* ═══════════════════════════════════════════ */}
//             {showMessageModal && (
//               <div
//                 className="modal d-block"
//                 tabIndex="-1"
//                 style={{
//                   backgroundColor: "rgba(0,0,0,0.5)",
//                   position: "fixed",
//                   top: 0,
//                   left: 0,
//                   width: "100%",
//                   height: "100%",
//                   zIndex: 99999,
//                 }}
//               >
//                 <div className="modal-dialog modal-dialog-centered">
//                   <div
//                     className="modal-content"
//                     style={{ borderRadius: "16px", border: "none" }}
//                   >
//                     <div
//                       className="modal-header"
//                       style={{
//                         background:
//                           messageModalContent.type === "success"
//                             ? "linear-gradient(135deg, #059669, #047857)"
//                             : messageModalContent.type === "error"
//                             ? "linear-gradient(135deg, #dc2626, #b91c1c)"
//                             : "linear-gradient(135deg, #d97706, #b45309)",
//                         color: "#ffffff",
//                         borderRadius: "16px 16px 0 0",
//                         border: "none",
//                       }}
//                     >
//                       <h5 className="modal-title" style={{ fontWeight: "800" }}>
//                         {messageModalContent.title}
//                       </h5>
//                       <button
//                         type="button"
//                         className="btn-close btn-close-white"
//                         onClick={closeCustomMessageModal}
//                       ></button>
//                     </div>
//                     <div
//                       className="modal-body"
//                       style={{
//                         padding: "24px",
//                         fontSize: "14px",
//                         color: "#334155",
//                       }}
//                     >
//                       {messageModalContent.text}
//                     </div>
//                     <div
//                       className="modal-footer"
//                       style={{ borderTop: "1.5px solid #e2e8f0" }}
//                     >
//                       {messageModalContent.confirmAction ? (
//                         <>
//                           <Button
//                             variant="secondary"
//                             onClick={closeCustomMessageModal}
//                           >
//                             Cancel
//                           </Button>
//                           <Button
//                             variant={
//                               messageModalContent.type === "warning"
//                                 ? "warning"
//                                 : "primary"
//                             }
//                             onClick={() => {
//                               messageModalContent.confirmAction();
//                               closeCustomMessageModal();
//                             }}
//                           >
//                             Confirm
//                           </Button>
//                         </>
//                       ) : (
//                         <Button
//                           variant={
//                             messageModalContent.type === "success"
//                               ? "success"
//                               : messageModalContent.type === "error"
//                               ? "danger"
//                               : "primary"
//                           }
//                           onClick={closeCustomMessageModal}
//                         >
//                           OK
//                         </Button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════
// // 🎨 SHARED STYLES
// // ═══════════════════════════════════════════
// const labelStyle = {
//   display: "block",
//   fontSize: "12.5px",
//   fontWeight: "700",
//   color: "#1e3a5f",
//   marginBottom: "6px",
// };

// const textDark = { margin: "4px 0", color: "#334155" };

// const dropdownItem = {
//   padding: "9px 12px",
//   borderRadius: "10px",
//   fontSize: "13px",
//   fontWeight: "600",
//   gap: "10px",
//   transition: "all 0.18s ease",
//   marginBottom: "2px",
//   border: "none",
//   background: "transparent",
//   width: "100%",
//   textAlign: "left",
//   color: "#1e5799",
// };

// const iconBadge = (bg, color) => ({
//   width: "28px",
//   height: "28px",
//   borderRadius: "8px",
//   background: bg,
//   color: color,
//   display: "inline-flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flexShrink: 0,
// });

// const paginationBtn = (disabled) => ({
//   width: "38px",
//   height: "38px",
//   borderRadius: "10px",
//   border: "1.5px solid #e2e8f0",
//   background: "#ffffff",
//   color: disabled ? "#cbd5e1" : "#1e5799",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   cursor: disabled ? "not-allowed" : "pointer",
// });

// export default InactiveProjectList;

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Tooltip } from "bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import {
  MdAirplanemodeInactive,
  MdAirplanemodeActive,
  MdOutlineUpcoming,
  MdUpcoming,
} from "react-icons/md";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = process.env.REACT_APP_Image_URL;
const LIMIT = 10; // ✅ Page size

function InactiveProjectList() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // ✅ NEW
  const [searchName, setSearchName] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedimagePath, setSelectedimagePath] = useState(null);
  const [viewModalImages, setViewModalImages] = useState([]);
  const searchTimeoutRef = useRef(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [amenitiesList, setAmenitiesList] = useState([]);

  const [editFormData, setEditFormData] = useState({
    name: "",
    project_size: "",
    status: "",
    project_status: "",
    project_id: "",
    newImages: [],
    images: [],
    newPDFs: [],
    pdfs: [],
    singleImageFile: null,
    current_single_image_url: null,
    imageprojectmap: null,
    imageprojectmap_image_url: null,
    rera_registration_no: "",
    location: "",
    project_type: "",
    description: "",
    legality: "",
    businessVolume: "",
    city: "",
    state: "",
    landmark: "",
    youtube_links: "",
    propertyChainPapers: [],
    availableAmenities: [],
    keyTransports: [],
    amenities: [],
  });

  const newMultiImageInputRef = useRef(null);
  const newSingleImageInputRef = useRef(null);
  const newMapImageInputRef = useRef(null);
  const newMultiPDFInputRef = useRef(null);

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });
  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 TOOLTIP INIT
  // ═══════════════════════════════════════════
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.map((el) => new Tooltip(el));
  }, [projects]);

  // ═══════════════════════════════════════════
  // 🔹 FETCH STATES & AMENITIES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const token = getAuthToken();
        if (!token) return;
        const response = await fetch(`${API_URL}/state-list`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch states.");
        const data = await response.json();
        setStates(data.data || []);
      } catch (err) {
        console.error("Fetch states error:", err);
      }
    };

    const fetchAmenities = async () => {
      try {
        const token = getAuthToken();
        if (!token) return;
        const response = await fetch(`${API_URL}/amenities-list`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch amenities.");
        const data = await response.json();
        setAmenitiesList(data.data || []);
      } catch (err) {
        console.error("Fetch amenities error:", err);
      }
    };

    fetchStates();
    fetchAmenities();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH CITIES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchCities = async () => {
      if (editFormData.state) {
        try {
          const token = getAuthToken();
          if (!token) return;
          const response = await fetch(`${API_URL}/city-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ state_id: editFormData.state }),
          });
          if (!response.ok) throw new Error("Failed to fetch cities.");
          const data = await response.json();
          setCities(data.data || []);
        } catch (err) {
          console.error("Fetch cities error:", err);
        }
      } else {
        setCities([]);
        setEditFormData((prev) => ({ ...prev, city: "" }));
      }
    };
    fetchCities();
  }, [editFormData.state]);

  // ═══════════════════════════════════════════
  // 🔹 MESSAGE MODAL
  // ═══════════════════════════════════════════
  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH PROJECTS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchProjects = async (page = 1, name = "") => {
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(
        `${API_URL}/project-list-inactive?page=${page}&limit=${LIMIT}&name=${name}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          showCustomMessageModal(
            "Authorization Error",
            "Unauthorized: Please log in again.",
            "error"
          );
        }
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch projects.");
      }

      const data = await response.json();
      setProjects(data.data || []);
      setSelectedimagePath(data.imagePath);

      // ✅ Server se totalPages aur total dono set karo
      const pages = Number(data.totalPages) || 1;
      const total = Number(data.total) || (data.data?.length || 0);

      setTotalPages(pages);
      setTotalItems(total);
      setCurrentPage(Number(data.currentPage) || Number(page));
    } catch (err) {
      console.error("Fetch projects error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects(currentPage, searchName);
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchName(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      setCurrentPage(1);
      fetchProjects(1, value);
    }, 500);
  };

  // ═══════════════════════════════════════════
  // 🔹 VIEW PROJECT
  // ═══════════════════════════════════════════
  const handleViewProject = async (projectId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/project-view`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: projectId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch project details.");
      }

      const data = await response.json();
      const projectData = data.data;

      const safeParse = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      };

      const imagesArray = safeParse(projectData.images);
      const amenitiesArray = safeParse(projectData.aminities);
      const parsedPropertyChainPapers = safeParse(
        projectData.property_chain_papers
      );

      setSelectedProject({
        ...projectData,
        images: imagesArray,
        aminities: amenitiesArray,
        property_chain_papers: parsedPropertyChainPapers,
      });

      setViewModalImages(imagesArray);
      setShowViewModal(true);
    } catch (err) {
      console.error("View project error:", err);
      showCustomMessageModal(
        "Error",
        err.message || "Failed to load project details.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT PROJECT
  // ═══════════════════════════════════════════
  const handleEditProject = async (projectId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/project-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: projectId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch project for editing."
        );
      }
      const data = await response.json();
      const projectData = data.data;

      const safeParse = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      };

      let parsedAmenities = [];
      if (projectData.aminities) {
        const amenitiesData = safeParse(projectData.aminities);
        parsedAmenities = amenitiesData.map((a) => String(a.id || a));
      }

      const parsedKeyTransports = safeParse(projectData.key_transport);
      const imagesArrayRaw = safeParse(projectData.images);

      const imagesArray = imagesArrayRaw.filter((file) =>
        /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.image || file)
      );

      const pdfsArray = imagesArrayRaw
        .filter((file) => /\.pdf$/i.test(file.image || file))
        .map((file) => ({
          ...file,
          pdf: file.image || file,
          thumbnail: "assets/pdf-thumbnail.png",
        }));

      const parsedPropertyChainPapers = safeParse(
        projectData.property_chain_papers
      );

      setEditFormData({
        name: projectData.name || "",
        project_size: projectData.total_township_area || "",
        status: projectData.status || "inactive",
        project_status: projectData.project_status || "ongoing",
        project_id: projectData.id || "",
        newImages: [],
        images: imagesArray,
        pdfs: pdfsArray,
        newPDFs: [],
        singleImageFile: null,
        imageprojectmap: null,
        current_single_image_url: projectData.thumbnail || null,
        imageprojectmap_image_url: projectData.map_pdf || null,
        rera_registration_no: projectData.project_rera_no || "",
        location: projectData.location || "",
        project_type: projectData.project_type || "",
        description: projectData.description || "",
        legality: projectData.approve_authority || "",
        businessVolume: projectData.bussiness_volume || "",
        city: projectData.city || "",
        state: projectData.state || "",
        landmark: projectData.land_mark || "",
        youtube_links: projectData.youtube_links || "",
        propertyChainPapers: parsedPropertyChainPapers,
        amenities: parsedAmenities,
        keyTransports: parsedKeyTransports,
      });

      setShowEditModal(true);
    } catch (err) {
      console.error("Edit project error:", err);
      showCustomMessageModal(
        "Error",
        err.message || "An unexpected error occurred.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 FORM HANDLERS
  // ═══════════════════════════════════════════
  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewMultiImageChange = (e) =>
    setEditFormData((prev) => ({
      ...prev,
      newImages: Array.from(e.target.files),
    }));

  const handleNewMultiPDFChange = (e) =>
    setEditFormData((prev) => ({
      ...prev,
      newPDFs: [...(prev.newPDFs || []), ...Array.from(e.target.files)],
    }));

  const handleNewSingleImageChange = (e) =>
    setEditFormData((prev) => ({
      ...prev,
      singleImageFile: e.target.files[0],
    }));

  const handleNewMapImageChange = (e) =>
    setEditFormData((prev) => ({
      ...prev,
      imageprojectmap: e.target.files[0],
    }));

  const removeNewMultiImage = (i) =>
    setEditFormData((prev) => ({
      ...prev,
      newImages: prev.newImages.filter((_, idx) => idx !== i),
    }));

  const removeNewMultiPDF = (i) =>
    setEditFormData((prev) => ({
      ...prev,
      newPDFs: prev.newPDFs.filter((_, idx) => idx !== i),
    }));

  const handleDescriptionChange = (event, editor) =>
    setEditFormData((prev) => ({ ...prev, description: editor.getData() }));

  const handleAmenitiesChange = (e) =>
    setEditFormData((prev) => ({
      ...prev,
      amenities: Array.from(e.target.selectedOptions).map((o) => o.value),
    }));

  const handleKeyTransportChange = (index, field, value) =>
    setEditFormData((prev) => {
      const updated = [...prev.keyTransports];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, keyTransports: updated };
    });

  const addKeyTransport = () =>
    setEditFormData((prev) => ({
      ...prev,
      keyTransports: [...prev.keyTransports, { name: "", distance: "" }],
    }));

  const removeKeyTransport = (i) =>
    setEditFormData((prev) => ({
      ...prev,
      keyTransports: prev.keyTransports.filter((_, idx) => idx !== i),
    }));

  // ═══════════════════════════════════════════
  // 🔹 UPDATE PROJECT
  // ═══════════════════════════════════════════
  const handleUpdateProject = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found.",
          "error"
        );
        return;
      }

      const formData = new FormData();
      formData.append("project_id", editFormData.project_id);
      formData.append("total_township_area", editFormData.project_size);
      formData.append("project_rera_no", editFormData.rera_registration_no);
      formData.append("location", editFormData.location);
      formData.append("bussiness_volume", editFormData.businessVolume);
      formData.append("description", editFormData.description);
      formData.append("approve_authority", editFormData.legality);
      formData.append("state", editFormData.state);
      formData.append("city", editFormData.city);
      formData.append("land_mark", editFormData.landmark);
      formData.append("youtube_links", editFormData.youtube_links);
      formData.append("project_status", editFormData.project_status);
      formData.append("status", editFormData.status);

      if (editFormData.singleImageFile) {
        formData.append("thumbnail", editFormData.singleImageFile);
      }
      if (editFormData.imageprojectmap) {
        formData.append("map_pdf", editFormData.imageprojectmap);
      }

      const amenitiesArrayOfObjects = editFormData.amenities.map((id) => ({
        id: String(id),
      }));
      formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));
      formData.append("key_transport", JSON.stringify(editFormData.keyTransports));

      if (editFormData.newPDFs?.length) {
        editFormData.newPDFs.forEach((f) =>
          formData.append("property_chain_papers[]", f)
        );
      }
      if (editFormData.newImages?.length) {
        editFormData.newImages.forEach((f) => formData.append("image[]", f));
      }

      const response = await fetch(`${API_URL}/project-update`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update project.");
      }

      const result = await response.json();
      if (result.success == "1") {
        showCustomMessageModal(
          "Success",
          "Project updated successfully!",
          "success"
        );
        setShowEditModal(false);
        fetchProjects(currentPage, searchName);
      }
    } catch (err) {
      console.error("Update project error:", err);
      showCustomMessageModal("Error", err.message || "Error occurred.", "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATES
  // ═══════════════════════════════════════════
  const handleStatusUpdate = (projectId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    showCustomMessageModal(
      "Confirm Status Change",
      `Do you want to change the Project Status to ${newStatus}?`,
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/project-status-update`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ status: newStatus, project_id: projectId }),
          });
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update status.");
          }
          showCustomMessageModal("Success", "Project status updated!", "success");
          fetchProjects(currentPage, searchName);
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleProjectStatusUpdate = (projectId, currentProjectStatus) => {
    const newProjectStatus =
      currentProjectStatus === "ongoing" ? "complete" : "ongoing";
    showCustomMessageModal(
      "Confirm Project Status Change",
      `Do you want to change to ${newProjectStatus}?`,
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(
            `${API_URL}/project-project-status-update`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                status: newProjectStatus,
                project_id: projectId,
              }),
            }
          );
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update.");
          }
          showCustomMessageModal("Success", "Project Status updated!", "success");
          fetchProjects(currentPage, searchName);
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleDeleteProject = (projectId) => {
    showCustomMessageModal(
      "Confirm Deletion",
      "Are you sure you want to delete this project? This action cannot be undone.",
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/project-delete`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: projectId }),
          });
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to delete project.");
          }
          showCustomMessageModal(
            "Success",
            "Project deleted successfully!",
            "success"
          );
          fetchProjects(currentPage, searchName);
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedProject(null);
    setViewModalImages([]);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedProject(null);
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING / ERROR
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-5" role="alert">
        {error}
        <button className="btn btn-primary ms-3" onClick={() => fetchProjects()}>
          Retry
        </button>
      </div>
    );
  }

  const parsedImages =
    typeof viewModalImages === "string"
      ? JSON.parse(viewModalImages)
      : viewModalImages || [];

  const imageFiles = parsedImages.filter((file) =>
    /\.(jpg|jpeg|png|gif|webp)$/i.test(
      typeof file === "string" ? file : file.image
    )
  );

  const pdfFiles = parsedImages.filter((file) =>
    /\.pdf$/i.test(typeof file === "string" ? file : file.image)
  );

  // ═══════════════════════════════════════════
  // 🎨 PAGINATION PAGES GENERATOR
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);

    if (showEllipsis && currentPage > 4) {
      pages.push("left-ellipsis");
    }

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (showEllipsis && currentPage < totalPages - 3) {
      pages.push("right-ellipsis");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                🏢
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Hide Projects
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all hidden real estate projects ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <div style={{ position: "relative" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#1e5799",
                    fontSize: "13px",
                    pointerEvents: "none",
                  }}
                >
                  🔍
                </span>
                <input
                  type="text"
                  placeholder="Search by project name..."
                  value={searchName}
                  onChange={handleSearchChange}
                  style={{
                    width: "240px",
                    padding: "10px 14px 10px 36px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    fontSize: "13.5px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
              </div>

              <Link
                to="/create-project"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Project
              </Link>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                }}
              >
                <input
                  type="text"
                  placeholder="Search by project name"
                  value={searchName}
                  onChange={handleSearchChange}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    fontSize: "13.5px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Name",
                      "Total Townships",
                      "Location",
                      "Business Vol.",
                      "Approved Authority",
                      "Date",
                      "Status",
                      "Project Status",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {projects?.length > 0 ? (
                    projects.map((project, i) => {
                      const globalIndex = (currentPage - 1) * LIMIT + i + 1;
                      return (
                        <tr
                          key={project.id}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <td style={cellBlue}>{globalIndex}</td>
                          <td style={cellDark}>{project.name || ""}</td>
                          <td style={cellGray}>{project.total_township_area}</td>
                          <td style={cellText}>{project.location || ""}</td>
                          <td style={cellGray}>{project.bussiness_volume}</td>
                          <td style={cellText}>{project.approve_authority || ""}</td>
                          <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                            {project.date}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 12px",
                                borderRadius: "20px",
                                fontSize: "11.5px",
                                fontWeight: "700",
                                background:
                                  project.status === "active"
                                    ? "#e7f9eb"
                                    : "#feeaeb",
                                color:
                                  project.status === "active"
                                    ? "#059669"
                                    : "#dc2626",
                              }}
                            >
                              {project.status === "active" ? "Show" : "Hide"}
                            </span>
                          </td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 12px",
                                borderRadius: "20px",
                                fontSize: "11.5px",
                                fontWeight: "700",
                                background:
                                  project.project_status === "ongoing"
                                    ? "#e8f1fb"
                                    : "#f3e8ff",
                                color:
                                  project.project_status === "ongoing"
                                    ? "#1e5799"
                                    : "#7c3aed",
                                textTransform: "capitalize",
                              }}
                            >
                              {project.project_status}
                            </span>
                          </td>
                          <td style={{ padding: "12px" }}>
                            <div className="dropdown">
                              <button
                                className="btn dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                data-bs-boundary="viewport"
                                data-bs-popper-config='{"strategy":"fixed"}'
                                aria-expanded="false"
                                style={{
                                  background: "#f8fafc",
                                  border: "1.5px solid #e2e8f0",
                                  borderRadius: "8px",
                                  width: "36px",
                                  height: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#1e5799",
                                  padding: 0,
                                }}
                              >
                                <BsThreeDots size={18} />
                              </button>
                              <ul
                                className="dropdown-menu"
                                style={{
                                  zIndex: 9999,
                                  borderRadius: "14px",
                                  border: "none",
                                  padding: "8px",
                                  boxShadow:
                                    "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                  minWidth: "230px",
                                  marginTop: "8px",
                                  background: "#ffffff",
                                }}
                              >
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleViewProject(project.id)}
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = "#e8f1fb";
                                      e.currentTarget.style.transform = "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = "transparent";
                                      e.currentTarget.style.transform = "translateX(0)";
                                    }}
                                  >
                                    <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                      <FaEye size={13} />
                                    </span>
                                    View Details
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleEditProject(project.id)}
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = "#e7f9eb";
                                      e.currentTarget.style.transform = "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = "transparent";
                                      e.currentTarget.style.transform = "translateX(0)";
                                    }}
                                  >
                                    <span style={iconBadge("#e7f9eb", "#059669")}>
                                      <FaEdit size={13} />
                                    </span>
                                    Edit Project
                                  </button>
                                </li>

                                <li>
                                  <hr
                                    style={{
                                      margin: "6px 8px",
                                      border: "none",
                                      borderTop: "1.5px dashed #e2e8f0",
                                    }}
                                  />
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() =>
                                      handleStatusUpdate(project.id, project.status)
                                    }
                                    style={{
                                      ...dropdownItem,
                                      color:
                                        project.status === "active"
                                          ? "#dc2626"
                                          : "#059669",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        project.status === "active" ? "#feeaeb" : "#e7f9eb";
                                      e.currentTarget.style.transform = "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = "transparent";
                                      e.currentTarget.style.transform = "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge(
                                        project.status === "active" ? "#feeaeb" : "#e7f9eb",
                                        project.status === "active" ? "#dc2626" : "#059669"
                                      )}
                                    >
                                      {project.status === "active" ? (
                                        <MdAirplanemodeInactive size={13} />
                                      ) : (
                                        <MdAirplanemodeActive size={13} />
                                      )}
                                    </span>
                                    {project.status === "active"
                                      ? "Deactivate"
                                      : "Activate"}
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() =>
                                      handleProjectStatusUpdate(
                                        project.id,
                                        project.project_status
                                      )
                                    }
                                    style={{ ...dropdownItem, color: "#7c3aed" }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = "#f3e8ff";
                                      e.currentTarget.style.transform = "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = "transparent";
                                      e.currentTarget.style.transform = "translateX(0)";
                                    }}
                                  >
                                    <span style={iconBadge("#f3e8ff", "#7c3aed")}>
                                      {project.project_status === "ongoing" ? (
                                        <MdUpcoming size={13} />
                                      ) : (
                                        <MdOutlineUpcoming size={13} />
                                      )}
                                    </span>
                                    {project.project_status === "ongoing"
                                      ? "Mark Completed"
                                      : "Mark Ongoing"}
                                  </button>
                                </li>

                                <li>
                                  <hr
                                    style={{
                                      margin: "6px 8px",
                                      border: "none",
                                      borderTop: "1.5px dashed #e2e8f0",
                                    }}
                                  />
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleDeleteProject(project.id)}
                                    style={{ ...dropdownItem, color: "#dc2626" }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = "#feeaeb";
                                      e.currentTarget.style.transform = "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = "transparent";
                                      e.currentTarget.style.transform = "translateX(0)";
                                    }}
                                  >
                                    <span style={iconBadge("#feeaeb", "#dc2626")}>
                                      <RiDeleteBin3Fill size={13} />
                                    </span>
                                    Delete Project
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="10"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No projects found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }

                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}

            {/* ═══════════════════════════════════════════ */}
            {/* 🎯 VIEW MODAL */}
            {/* ═══════════════════════════════════════════ */}
            <Modal
              show={showViewModal}
              onHide={handleCloseViewModal}
              size="xl"
              centered
              backdrop="static"
              style={{ zIndex: 99999 }}
            >
              <Modal.Header
                closeButton
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  border: "none",
                }}
              >
                <Modal.Title style={{ fontWeight: "800" }}>
                  📋 Project Details
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{ padding: "24px", maxHeight: "75vh", overflowY: "auto" }}
              >
                {selectedProject && (
                  <>
                    {selectedProject.thumbnail && (
                      <div style={{ marginBottom: "20px" }}>
                        <strong style={labelColor}>Main Image:</strong>
                        <div style={{ marginTop: "8px" }}>
                          <img
                            src={`${imageAPIURL}/project/${selectedProject.thumbnail}`}
                            alt="thumbnail"
                            style={{
                              width: "100%",
                              maxHeight: "340px",
                              objectFit: "cover",
                              borderRadius: "12px",
                              border: "1.5px solid #e2e8f0",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            }}
                            onError={(e) => (e.target.style.display = "none")}
                          />
                        </div>
                      </div>
                    )}

                    <Row className="mb-3">
                      <Col md={6}>
                        <strong style={labelColor}>Project Name:</strong>
                        <p style={textDark}>{selectedProject.name || "N/A"}</p>
                      </Col>
                      <Col md={6}>
                        <strong style={labelColor}>Total Township Area:</strong>
                        <p style={textDark}>
                          {selectedProject.total_township_area || "N/A"}
                        </p>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <strong style={labelColor}>Location:</strong>
                        <p style={textDark}>{selectedProject.location || "N/A"}</p>
                      </Col>
                      <Col md={6}>
                        <strong style={labelColor}>State / City:</strong>
                        <p style={textDark}>
                          {selectedProject.state || "N/A"} /{" "}
                          {selectedProject.city || "N/A"}
                        </p>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <strong style={labelColor}>RERA No:</strong>
                        <p style={textDark}>
                          {selectedProject.project_rera_no || "N/A"}
                        </p>
                      </Col>
                      <Col md={6}>
                        <strong style={labelColor}>Approved Authority:</strong>
                        <p style={textDark}>
                          {selectedProject.approve_authority || "N/A"}
                        </p>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <strong style={labelColor}>Business Volume:</strong>
                        <p style={textDark}>
                          {selectedProject.bussiness_volume || "N/A"}
                        </p>
                      </Col>
                      <Col md={6}>
                        <strong style={labelColor}>Landmark:</strong>
                        <p style={textDark}>{selectedProject.land_mark || "N/A"}</p>
                      </Col>
                    </Row>

                    {selectedProject.location_map && (
                      <Row className="mb-3">
                        <Col md={12}>
                          <strong style={labelColor}>Location Map:</strong>
                          <p style={{ margin: "4px 0" }}>
                            <a
                              href={selectedProject.location_map}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#1e5799", fontWeight: "600" }}
                            >
                              🗺️ Open in Google Maps
                            </a>
                          </p>
                        </Col>
                      </Row>
                    )}

                    <Row className="mb-3">
                      <Col md={12}>
                        <strong style={labelColor}>Description:</strong>
                        <div
                          style={{ margin: "4px 0", color: "#334155" }}
                          dangerouslySetInnerHTML={{
                            __html: selectedProject.description || "N/A",
                          }}
                        />
                      </Col>
                    </Row>

                    {selectedProject.images &&
                      selectedProject.images.length > 0 && (
                        <div className="mb-3">
                          <strong style={labelColor}>Project Gallery:</strong>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "repeat(auto-fill, minmax(140px, 1fr))",
                              gap: "10px",
                              marginTop: "10px",
                            }}
                          >
                            {selectedProject.images.map((img, idx) => {
                              const imgName =
                                typeof img === "string" ? img : img.image;
                              return (
                                <div
                                  key={idx}
                                  style={{
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    border: "1.5px solid #e2e8f0",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                  }}
                                >
                                  <img
                                    src={`${imageAPIURL}/project/${imgName}`}
                                    alt={`project-${idx}`}
                                    style={{
                                      width: "100%",
                                      height: "120px",
                                      objectFit: "cover",
                                      display: "block",
                                      cursor: "pointer",
                                      transition: "transform 0.3s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.transform = "scale(1.08)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.transform = "scale(1)")
                                    }
                                    onClick={() =>
                                      window.open(
                                        `${imageAPIURL}/project/${imgName}`,
                                        "_blank"
                                      )
                                    }
                                    onError={(e) => (e.target.style.display = "none")}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                    {selectedProject.aminities &&
                      selectedProject.aminities.length > 0 && (
                        <div className="mb-3">
                          <strong style={labelColor}>Amenities:</strong>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                              marginTop: "10px",
                            }}
                          >
                            {selectedProject.aminities.map((am, idx) => (
                              <span
                                key={idx}
                                style={{
                                  padding: "6px 12px",
                                  borderRadius: "20px",
                                  background: "#e8f1fb",
                                  color: "#1e5799",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                ✨ {typeof am === "object" ? am.name : am}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}

                    {pdfFiles.length > 0 && (
                      <div className="mb-3">
                        <strong style={labelColor}>Project PDFs:</strong>
                        <ul style={{ marginTop: "8px" }}>
                          {pdfFiles.map((pdf, idx) => {
                            const pName =
                              typeof pdf === "string" ? pdf : pdf.image;
                            return (
                              <li key={idx}>
                                <a
                                  href={`${imageAPIURL}/project/${pName}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#1e5799", fontWeight: "600" }}
                                >
                                  📄 {pName}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseViewModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

            {/* ═══════════════════════════════════════════ */}
            {/* 🎯 EDIT MODAL */}
            {/* ═══════════════════════════════════════════ */}
            <Modal
              show={showEditModal}
              onHide={handleCloseEditModal}
              size="lg"
              centered
              backdrop="static"
              style={{ zIndex: 99999 }}
            >
              <Modal.Header
                closeButton
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  border: "none",
                }}
              >
                <Modal.Title style={{ fontWeight: "800" }}>
                  ✏️ Edit Project
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
              >
                <Form onSubmit={handleUpdateProject}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>Project Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={editFormData.name}
                          onChange={handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>
                          Total Township Area
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="project_size"
                          value={editFormData.project_size}
                          onChange={handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>RERA No</Form.Label>
                        <Form.Control
                          type="text"
                          name="rera_registration_no"
                          value={editFormData.rera_registration_no}
                          onChange={handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>Location</Form.Label>
                        <Form.Control
                          type="text"
                          name="location"
                          value={editFormData.location}
                          onChange={handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>
                          Business Volume
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="businessVolume"
                          value={editFormData.businessVolume}
                          onChange={handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>
                          Approved Authority
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="legality"
                          value={editFormData.legality}
                          onChange={handleEditFormChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>State</Form.Label>
                        <Form.Select
                          name="state"
                          value={editFormData.state}
                          onChange={handleEditFormChange}
                        >
                          <option value="">Select State</option>
                          {states.map((s) => (
                            <option key={s.id} value={s.id}>
                              {s.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>City</Form.Label>
                        <Form.Select
                          name="city"
                          value={editFormData.city}
                          onChange={handleEditFormChange}
                        >
                          <option value="">Select City</option>
                          {cities.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>Landmark</Form.Label>
                    <Form.Control
                      type="text"
                      name="landmark"
                      value={editFormData.landmark}
                      onChange={handleEditFormChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>YouTube Link</Form.Label>
                    <Form.Control
                      type="text"
                      name="youtube_links"
                      value={editFormData.youtube_links}
                      onChange={handleEditFormChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>Description</Form.Label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={editFormData.description}
                      onChange={handleDescriptionChange}
                    />
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>Status</Form.Label>
                        <Form.Select
                          name="status"
                          value={editFormData.status}
                          onChange={handleEditFormChange}
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>
                          Project Status
                        </Form.Label>
                        <Form.Select
                          name="project_status"
                          value={editFormData.project_status}
                          onChange={handleEditFormChange}
                        >
                          <option value="ongoing">Ongoing</option>
                          <option value="complete">Complete</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Button
                    variant="primary"
                    type="submit"
                    disabled={loading}
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "10px",
                      fontWeight: "700",
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      border: "none",
                    }}
                  >
                    {loading ? "Updating..." : "Update Project"}
                  </Button>
                </Form>
              </Modal.Body>
            </Modal>

            {/* ═══════════════════════════════════════════ */}
            {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
            {/* ═══════════════════════════════════════════ */}
            {showMessageModal && (
              <div
                className="modal d-block"
                tabIndex="-1"
                style={{
                  backgroundColor: "rgba(0,0,0,0.5)",
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 99999,
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div
                    className="modal-content"
                    style={{
                      borderRadius: "16px",
                      border: "none",
                      overflow: "hidden",
                      boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
                    }}
                  >
                    <div
                      style={{
                        background: "#1e5799",
                        color: "#ffffff",
                        padding: "16px 24px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                        {messageModalContent.title}
                      </h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        aria-label="Close"
                        onClick={closeCustomMessageModal}
                      ></button>
                    </div>
                    <div
                      className="modal-body"
                      style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
                    >
                      {messageModalContent.text}
                    </div>
                    <div
                      className="modal-footer"
                      style={{
                        borderTop: "1.5px solid #e2e8f0",
                        padding: "16px 24px",
                        gap: "10px",
                      }}
                    >
                      {messageModalContent.confirmAction ? (
                        <>
                          <button
                            type="button"
                            onClick={closeCustomMessageModal}
                            style={{
                              padding: "10px 22px",
                              borderRadius: "10px",
                              border: "1.5px solid #e2e8f0",
                              background: "#ffffff",
                              color: "#64748b",
                              fontSize: "13px",
                              fontWeight: "700",
                              cursor: "pointer",
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              messageModalContent.confirmAction();
                              closeCustomMessageModal();
                            }}
                            style={{
                              padding: "10px 22px",
                              borderRadius: "10px",
                              border: "none",
                              background: "#1e5799",
                              color: "#ffffff",
                              fontSize: "13px",
                              fontWeight: "700",
                              cursor: "pointer",
                              boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                            }}
                          >
                            Confirm
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          onClick={closeCustomMessageModal}
                          style={{
                            padding: "10px 22px",
                            borderRadius: "10px",
                            border: "none",
                            background: "#1e5799",
                            color: "#ffffff",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                          }}
                        >
                          OK
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const labelColor = { color: "#1e5799" };
const textDark = { margin: "4px 0", color: "#334155" };

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };
const cellText = {
  padding: "12px",
  color: "#334155",
  maxWidth: "240px",
  fontSize: "12.5px",
};

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const paginationBtn = (disabled) => ({
  width: "38px",
  height: "38px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  background: "#ffffff",
  color: disabled ? "#cbd5e1" : "#1e5799",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: disabled ? "not-allowed" : "pointer",
});

export default InactiveProjectList;
